import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Calendar, Share2, Facebook } from 'lucide-react';
import { XLogo } from '../components/XLogo';
import { api } from '../lib/api';

export default function NewsDetail() {
  const { slug } = useParams();
  const [n, setN] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    api.getNews(slug).then(setN).catch(() => setN(null));
    api.listNews().then(all => setRelated(all.filter(x => x.slug !== slug).slice(0, 3))).catch(() => setRelated([]));
  }, [slug]);

  if (!n) return <section className="bg-cream py-40 text-center text-ink-400">Yükleniyor...</section>;

  return (
    <>
      <section className="bg-cream pt-10 md:pt-14">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
          <Link to="/duyurular" className="inline-flex items-center gap-2 text-ink-500 hover:text-ink-600 text-sm font-medium"><ArrowLeft className="w-4 h-4" /> Tüm duyurular</Link>
          <div className="flex items-center gap-3 mt-8 text-[11px] uppercase tracking-widest">
            <span className="bg-gold text-ink-700 rounded-full px-3 py-1 font-semibold">{n.category}</span>
            <span className="text-ink-400 inline-flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {n.date}</span>
          </div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] text-ink-600 mt-5">{n.title}</h1>
          <p className="mt-5 text-xl text-ink-500 leading-relaxed">{n.excerpt}</p>
        </div>
      </section>

      <section className="bg-cream">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10 mt-10">
          <div className="rounded-3xl overflow-hidden aspect-[16/9] bg-ink-50">
            <img src={n.image} alt={n.title} className="w-full h-full object-cover" />
          </div>
          <div className="grid lg:grid-cols-12 gap-10 mt-14 pb-20">
            <aside className="lg:col-span-3 lg:sticky lg:top-28 self-start">
              <div className="text-[10px] uppercase tracking-widest text-ink-400 font-semibold mb-3">Paylaş</div>
              <div className="flex lg:flex-col gap-2">
                <button className="w-10 h-10 rounded-full border border-ink-200 grid place-items-center text-ink-600 hover:bg-ink-600 hover:text-cream hover:border-ink-600 transition-colors"><Facebook className="w-4 h-4" /></button>
                <button className="w-10 h-10 rounded-full border border-ink-200 grid place-items-center text-ink-600 hover:bg-ink-600 hover:text-cream hover:border-ink-600 transition-colors"><XLogo className="w-4 h-4" /></button>
                <button className="w-10 h-10 rounded-full border border-ink-200 grid place-items-center text-ink-600 hover:bg-ink-600 hover:text-cream hover:border-ink-600 transition-colors"><Share2 className="w-4 h-4" /></button>
              </div>
            </aside>
            <article className="lg:col-span-9 prose prose-lg max-w-none">
              <div
                className="news-content text-ink-600 text-lg leading-relaxed"
                dangerouslySetInnerHTML={{ __html: n.content || '' }}
              />
              <style>{`
                .news-content h1{font-family:'Playfair Display',Georgia,serif;font-size:2.2rem;line-height:1.15;margin:1.4em 0 0.5em;color:#0F1E4D}
                .news-content h2{font-family:'Playfair Display',Georgia,serif;font-size:1.7rem;line-height:1.2;margin:1.2em 0 0.4em;color:#0F1E4D}
                .news-content h3{font-family:'Playfair Display',Georgia,serif;font-size:1.35rem;margin:1em 0 0.3em;color:#0F1E4D}
                .news-content p{margin:0.8em 0}
                .news-content ul, .news-content ol{padding-left:1.6em;margin:0.8em 0}
                .news-content ul li{list-style:disc;margin:0.3em 0}
                .news-content ol li{list-style:decimal;margin:0.3em 0}
                .news-content blockquote{border-left:3px solid #C9A96E;padding-left:1.2em;color:#374060;font-style:italic;margin:1.2em 0;font-size:1.15em}
                .news-content a{color:#0F1E4D;text-decoration:underline;text-underline-offset:3px}
                .news-content a:hover{color:#C9A96E}
                .news-content img{border-radius:0.75rem;max-width:100%;margin:1.2em 0}
                .news-content hr{border:0;border-top:1px solid #E8DECF;margin:1.6em 0}
                .news-content code{background:#F4EEE2;padding:0.15em 0.4em;border-radius:4px;font-size:0.9em}
              `}</style>
              <p className="text-ink-600 text-lg leading-relaxed mt-6">YEKÜV olarak, Türkiye\'nin dört bir yanında yaşayan çocuk ve gençlerimize ulaşmak için bütünsel bir yaklaşım benimsiyoruz. Bu etkinliğimiz, vakfımızın yayımladığı yıllık faaliyet raporunda ayrıntılı olarak yer alacaktır.</p>
              <blockquote className="border-l-4 border-gold pl-6 my-10 font-display text-2xl italic text-ink-600">“Bir çocuk daha okusun diye, 33 yıldır aynı hayalin peşindeyiz.”</blockquote>
              <p className="text-ink-600 text-lg leading-relaxed">Bu tür faaliyetlerimizi desteklemek ve vakfımızın etki alanını genişletmek için siz de gönüllü olabilir veya bağış yapabilirsiniz.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="bg-cream-200">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
          <h3 className="font-display text-3xl md:text-4xl text-ink-600">İlgili duyurular</h3>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {related.map(r => (
              <Link key={r.id} to={`/duyurular/${r.slug}`} className="group bg-white rounded-3xl border border-ink-100 overflow-hidden">
                <div className="aspect-[4/3] overflow-hidden bg-ink-50">
                  <img src={r.image} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="text-[10px] uppercase tracking-widest text-coral-300 font-semibold">{r.category} · {r.date}</div>
                  <h4 className="font-display text-xl mt-2 text-ink-600">{r.title}</h4>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
